import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';
import { makeStyles } from 'legacyStyles';

import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

const Root = styled.div`
  margin: ${legacyTheme.spacing.s24} 0;
  padding: ${legacyTheme.spacing.s24} ${legacyTheme.spacing.s24} ${legacyTheme.spacing.s16};
  background: ${theme.colors.neutral[100]};
`;

const Title = styled(Typography)`
  margin-bottom: ${legacyTheme.spacing.s8};
`;

const Paragraph = styled(Typography)`
  margin-bottom: ${legacyTheme.spacing.s24};
`;

const useStyles = makeStyles(() => ({
  uploadCta: {
    display: 'block',
  },
}));

const SelfieUploader = ({ goToSelfieApp }) => {
  const { classes } = useStyles();

  return (
    <Root>
      <Title align="left" variant="h3">
        Want us to take a second look?
      </Title>
      <Paragraph align="left" color="grey" variant="p2">
        Upload 2 photos and our team of experts will make sure we didn’t miss anything in your
        consultation.
      </Paragraph>
      <Button classes={{ root: classes.uploadCta }} onClick={goToSelfieApp} variant="vert">
        Upload your photos
      </Button>
    </Root>
  );
};

SelfieUploader.propTypes = {
  goToSelfieApp: PropTypes.func.isRequired,
};

export default SelfieUploader;
